import script from "./ClaimDetailsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClaimDetailsModal.vue?vue&type=script&setup=true&lang=ts"

import "./ClaimDetailsModal.vue?vue&type=style&index=0&id=75afc2ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75afc2ba"]])

export default __exports__